import React from 'react';
import { Box, Chip } from '@mui/material';
import { tagColor } from '../../utils/tagColors';

/** A dot in the tag's color, also used beside tags in the tag picker. */
export function TagDot({ tag, sx }) {
  return (
    <Box
      component="span"
      sx={{ width: 8, height: 8, borderRadius: '50%', flexShrink: 0, bgcolor: tagColor(tag).dot, ...sx }}
    />
  );
}

/**
 * A tag the user gave a channel, such as "Mitom", as a soft pill in the tag's
 * own color. Extra props, such as onDelete, pass through to the Chip.
 */
export default function TagChip({ tag, ...chipProps }) {
  const color = tagColor(tag);
  return (
    <Chip
      size="small"
      label={tag}
      icon={<TagDot tag={tag} />}
      {...chipProps}
      sx={{
        bgcolor: color.background,
        color: color.text,
        fontWeight: 600,
        '& .MuiChip-icon': { ml: 1, mr: -0.25 },
        '& .MuiChip-deleteIcon': { color: color.text, opacity: 0.55 },
        '& .MuiChip-deleteIcon:hover': { color: color.text, opacity: 1 },
      }}
    />
  );
}
